import useUserPermissions from '@/hooks/useUserPermissions'
import { featureFlagKeys } from '@/utils/data/featureFlags'
import { Search } from '@mynaui/icons-react'
import { useRouter } from '@tanstack/react-router'
import { useFeatureFlagEnabled } from 'posthog-js/react'
import { useEffect, useState } from 'react'
import SearchDialog from '../SearchDialog'
import { LockTagSmall } from './LockTag'
import { Text } from './Text'

const SearchBarAndDialog = () => {
  const { permissions, authUser } = useUserPermissions()
  const [searchOpen, setSearchOpen] = useState<boolean>(false)
  const searchFlagEnabled = useFeatureFlagEnabled(featureFlagKeys.search)

  const router = useRouter()

  useEffect(() => {
    const unsubscribe = router.history.subscribe(() => {
      setSearchOpen(false)
    })

    return () => unsubscribe()
  }, [router])

  return searchFlagEnabled ? (
    <>
      {searchOpen && permissions ? <SearchDialog open={searchOpen} onOpenChange={() => setSearchOpen(false)} /> : null}
      <div
        className={`px-4 py-2 flex gap-3 items-center justify-between border-2 rounded-lg w-full lg:max-w-[30rem] transition-opacity duration-300 cursor-pointer bg-themebackground dark:bg-themebackgrounddark`}
        onClick={() => setSearchOpen(true)}
      >
        <div className="flex gap-3 items-center w-full">
          <Search className="h-5 w-5 " />
          <Text weight={'medium'} size="sm" className="text-thememutedforeground">
            Find it fast with Search
          </Text>
        </div>

        {authUser ? null : (
          <div className="opacity-50">
            <LockTagSmall />
          </div>
        )}
      </div>
    </>
  ) : null
}

export default SearchBarAndDialog
